var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 69,
    viewBox: "0 0 54 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 63.3965L48.0914 47.7461H5.9086L0 63.3965H21.6879C21.644 63.6475 21.6063 63.8984 21.6063 64.1555C21.6063 66.8277 23.7726 68.9918 26.4474 68.9918C29.1223 68.9918 31.2886 66.8277 31.2886 64.1555C31.2886 63.8984 31.2509 63.6412 31.2133 63.3965H54Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1503 10.2057C31.1503 10.1305 31.1566 10.0426 31.1566 9.96736C31.1566 5.01191 29.5429 0 26.4473 0C23.358 0 21.7443 5.01191 21.7443 9.96736C21.7443 10.0426 21.7568 10.1305 21.7568 10.2057C14.134 14.076 8.21288 27.1233 6.78125 43.5014H46.1133C44.688 27.1233 38.7668 14.076 31.1503 10.2057ZM26.4473 8.99509C25.7126 8.99509 24.9906 9.10173 24.2747 9.27109C24.4192 4.88645 25.8445 2.50282 26.4473 2.50282C27.0564 2.50282 28.4817 4.88645 28.6261 9.27109C27.9103 9.108 27.1882 8.99509 26.4473 8.99509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.a77d34fe7d0c82ab4208e162934afecd.svg";
export { ForwardRef as ReactComponent };